;(function () {
  angular.module('contrast.ui-select').directive('selectRequired', function () {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, elem, attrs, ngModel) {
        scope.$watch(attrs.ngModel, function (value) {
          var valid =
            !angular.isUndefined(value) &&
            (typeof value === 'object' ||
              (typeof value === 'string' && value.length > 0) ||
              typeof value === 'number')
          ngModel.$setValidity(attrs.ngModel, valid)
        })
      }
    }
  })
})()
